import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import { loadTasApplicationHistory } from 'tio-data/requests/tas-application-actions';
// This is for types. Anything we have custom may show an error.
import type { Store as StoreService } from '@warp-drive/core';
import type { TasApplicationExtension as TasApplicationModel } from 'tio-data/data/resources/tas-application.ext';
interface Params {
  tas_application_id: string;
}

export default class AuthenticatedAdminTasApplicationsApprovalRoute extends Route {
  @service declare store: StoreService;

  // Layout configuration - declares this route needs full-width layout
  // layoutType = 'full-width' as const;

  // @ts-expect-error - Route model signature mismatch with Ember Route types
  async model(params: Params): Promise<TasApplicationModel> {
    // Fetch the application with all related data needed for approval
    // Using new data structure with tas_fields as a relationship
    const { content } = (await this.store.request(
      findRecord<TasApplicationModel>('tas-application', params.tas_application_id, {
        include: [
          'tas-program-instance.tas-program-template.tas-field-options',
          'tas-program-instance.employee',
          'tas-program-instance.employee.person',
          'tas-program-instance.employee.company',
          'tas-program-instance.employee.company.comments',
          'tas-program-instance.employee.tas-participant',
          'tas-program-instance.tas-assets',
          'tas-program-instance.tas-assets.attachments',
          'tas-program-instance.tas-assets.asset-summary',
          'tas-program-limit',
          'tas-courses.tas-assets',
          'tas-courses.tas-assets.attachments',
          'tas-courses.tas-assets.asset-summary',
          'tas-assets',
          'tas-assets.attachments',
          'tas-assets.asset-summary',
          'tas-assistances',
          'attachments',
          'ai-recommendations',
          'comments',
          'comments.person',
        ],
      })
    )) as { content: { data: TasApplicationModel } };
    const application = content.data;

    await loadTasApplicationHistory(this.store, application);

    return application;
  }
}
